import React, {useEffect, useState} from 'react';
import {StreamBankLink} from "../StreamBankLink";
import {userProfileImage} from "../../../Redux/Selectors/userSelectors";
import {service as UserService} from "../../../Services/UserService";

export const UserTableColumn = (props) => {
    const { Value, showProfileImage = true } = props;
    
    const userId = Value?.userId ?? Value;

    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(Value?.userId ? Value : null);
    const showNA = () => {
        setUser(null);
        setLoading(false);
    }
    
    useEffect(() => {
        (async () => {
            if (user === null || Number(user?.userId) !== Number(userId)) {
                try {
                    if (userId !== null) {
                        setUser((await UserService.FindById(userId, true))?.result);
                        setLoading(false);
                    } else {
                        showNA();
                    }
                } catch(e) {
                    console.log('Failed to load user:', e);
                    showNA();
                }
            }
        })();
    }, [userId]);
    
    if(loading) {
        return <span>Loading...</span>;
    }
    
    if(!user) {
        return <span>N/A</span>;
    }

    return <StreamBankLink
        className="sb-actionable-link"
        Href={"/users/" + userId}
    >
        {
            showProfileImage ? <div className="sb-account-icon">
                <img src={userProfileImage(user)} alt=""/>
            </div> : null
        }
        {UserService.GetTitle(user)}
    </StreamBankLink>;
}
